export const getCookie = (name) => {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
      let split = el.split('=');
      cookie[split[0].trim()] = split.slice(1).join("=");
    })
    return cookie[name];
}

export const clearCookie = (name) => {
    document.cookie = name + '=null; path=/;';
}